// Import style lib
import styled from 'styled-components';

// Import colors
import colors from '../../utils/styles/colors';

// Styled about page wrapper
export const AboutWrapper = styled.main`
    /* Appearance */
    background-color: ${colors.primaryBeige};

    /* Element disposition */
    flex-grow: 1;

    /* Spacing */
    padding: 50px;

    /* Content disposition */
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 30px;

    /* Mobile setup */
    @media (max-width: 600px) {
        gap: 10px;

        padding: 10px;
    }
`;

// Wrapper for Infos cards
export const InfoSection = styled.section`
    /* Content disposition */
    display: flex;
    flex-wrap: wrap;
    align-content: flex-start;
    justify-content: center;
    gap: 50px;

    /* Size */
    max-width: 1200px;

    /* Mobile setup */
    @media (max-width: 600px) {
        gap: 10px;
    }
`;

// Styled info section
export const InfoCard = styled.div`
    /* Content disposition */
    display: flex;
    flex-direction: column;
    gap: 10px;

    /* Appearance */
    background-color: #fff;
    border-radius: 10px;

    /* Size */
    width: 500px;
    max-width: 85vw;

    /* Spacing */
    padding: 25px;

    /* Visual effects */
    box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.5);

    /* Mobile setup */
    @media (max-width: 600px) {
        padding: 15px;
        gap: 7px;
    }
`;

// Styled info title
export const InfoTitle = styled.h1`
    /* Element disposition */
    text-align: center;
`;

// Styled box for about infos content
export const InfoContent = styled.p`
    /* Apprearance */
    text-align: center;
    white-space: pre-wrap;
    line-height: 2;
`;

// Styled row for Info contact links
export const SocialNetworkRow = styled.div`
    /* Content disposition */
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 10px;

    /* Size */
    width: 100%;
    min-width: 0;
`;

// Styled external link
export const SocialNetworkLink = styled.a`
    /* Size */
    max-width: 80%;

    /* Element disposition */
    overflow-wrap: anywhere;
    word-break: break-all;

    /* Events */
    &:hover {
        text-decoration: underline;
    }
`;

// Styled svg
export const SocialNetworkIcon = styled.svg`
    /* Size */
    width: ${(props) => props.width}px;
    height: ${(props) => props.width}px;

    /* Element disposition */
    flex-shrink: 0;

    /* Events */
    &:hover {
        filter: brightness(1.2);
    }
`;

// Update buttons
export const EditButton = styled.button`
    align-self: flex-end;

    /* Events */
    cursor: pointer;
`;

// Update text area
export const EditTextArea = styled.textarea`
    /* Apprearance */
    border: solid 1px;
    text-align: center;
    white-space: pre-wrap;
    line-height: 2;

    /* Size */
    width: 100%;
    resize: vertical;
`;

// Settings Icon
export const Icon = styled.svg`
    /* Appearance */
    fill: ${colors.primaryBeige};

    /* Size */
    width: ${(props) => props.width}px;
    height: ${(props) => props.width}px;

    &:hover {
        filter: brightness(1.2);
    }
`;
